<section class="d-flex align-items-center justify-content-center mb-5 pt-5 pl-4 pr-4">
  <mat-card class="mat-elevation-z4 signup-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12">

          <form [formGroup]="signupForm" (ngSubmit)="userSignup()">
            <h1 class="mat-headline">Sign Up</h1>
            <p class="mb-3">Sign into your account</p>

            <div class="row">
              <!-- First Name -->
              <div class="col-md-6 mb-2">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>First Name</mat-label>
                  <input matInput formControlName="firstname" placeholder="First Name">
                  <mat-error class="matError" *ngIf="f['firstname'].touched && f['firstname'].invalid">
                    First name is required (min 2 characters)
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Last Name -->
              <div class="col-md-6 mb-2">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Last Name</mat-label>
                  <input matInput formControlName="lastname" placeholder="Last Name">
                  <mat-error class="matError" *ngIf="f['lastname'].touched && f['lastname'].invalid">
                    Last name is required (min 2 characters)
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- Email -->
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email</mat-label>
                <input matInput type="email" formControlName="email" placeholder="Email">
                <mat-error class="matError" *ngIf="f['email'].touched && f['email'].invalid">
                  Please enter a valid email address
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Phone -->
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Phone</mat-label>
                <input matInput type="tel" formControlName="phone" placeholder="Mobile">
                <mat-error class="matError" *ngIf="f['phone'].touched && f['phone'].invalid">
                  Enter a valid 10-digit phone number
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Password -->
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Password</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                  placeholder="Password">
                <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
                  <mat-icon>
                    {{ hidePassword ? 'visibility_off' : 'visibility' }}
                  </mat-icon>
                </button>
                <mat-error class="matError" *ngIf="f['password'].touched && f['password'].invalid">
                  Password must be minimum 6 characters
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Address -->
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>House No / Building Name</mat-label>
                <input matInput formControlName="house_no" placeholder="e.g. H.No 12, Plot 45, Shiv Shakti Bhawan">
                <mat-error class="matError" *ngIf="f['house_no'].touched && f['house_no'].invalid">
                  Please enter a valid House No
                </mat-error>
              </mat-form-field>
            </div>
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Street / Area / Village</mat-label>
                <input matInput formControlName="street_area" placeholder="e.g. Village , Road , Mohalla">
                <mat-error class="matError" *ngIf="f['street_area'].touched && f['street_area'].invalid">
                  Please enter a valid street area
                </mat-error>
              </mat-form-field>
            </div>
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Landmark</mat-label>
                <input matInput formControlName="landmark" placeholder="e.g Near Govt School / Temple / Bus Stand">
                <mat-error class="matError" *ngIf="f['landmark'].touched && f['landmark'].invalid">
                  Please enter a valid landmark
                </mat-error>
              </mat-form-field>
            </div>
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Post Office</mat-label>
                <input matInput formControlName="post_office" placeholder="Post Office">
                <mat-error class="matError" *ngIf="f['post_office'].touched && f['post_office'].invalid">
                  Please enter a valid post office
                </mat-error>
              </mat-form-field>
            </div>
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Tehsil</mat-label>
                <input matInput formControlName="tehsil" placeholder="Tehsil">
                <mat-error class="matError" *ngIf="f['tehsil'].touched && f['tehsil'].invalid">
                  Please enter a valid tehsil
                </mat-error>
              </mat-form-field>
            </div>
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>District</mat-label>
                <input matInput formControlName="district" placeholder="District">
                <mat-error class="matError" *ngIf="f['district'].touched && f['district'].invalid">
                  Please enter a valid district
                </mat-error>
              </mat-form-field>
            </div>
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>State</mat-label>
                <input matInput formControlName="state" placeholder="State">
                <mat-error class="matError" *ngIf="f['state'].touched && f['state'].invalid">
                  Please enter a valid state
                </mat-error>
              </mat-form-field>
            </div>
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Pincode</mat-label>
                <input matInput formControlName="pincode" placeholder="Pincode">
                <mat-error class="matError" *ngIf="f['pincode'].touched && f['pincode'].invalid">
                  Please enter a valid pincode
                </mat-error>
              </mat-form-field>
            </div>
            <div class="mb-2">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Country</mat-label>
                <input matInput formControlName="country" placeholder="Country">
                <mat-error class="matError" *ngIf="f['country'].touched && f['country'].invalid">
                  Please enter a valid country
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Submit -->
            <div class="text-right mt-4 mb-5">
              <button mat-raised-button color="primary" type="submit" [disabled]="signupForm.invalid">
                Register
              </button>
            </div>

          </form>

        </div>
      </div>
    </div>
  </mat-card>
</section>
<br><br><br><br>